










import { Vue, Component } from 'vue-property-decorator';
import ClientesConecta from '@/pantallas/Conecta/Clientes/ClientesConecta.vue';

@Component({
  components: { ClientesConecta },
})
export default class ClientesConectaPantalla extends Vue {}
